import React, { useState, useEffect } from "react";
import { TosPageStyle } from "./Configuration.style";
import TopBar from "../../components/TopBar/TopBar";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import { HeadingStyle } from "../../styles/HeadingStyles";
import RichTextEditor from "react-rte";
import { TextErrorStyle } from "../../styles/ErrorStyles";
import Footer from "../../components/footer/Footer";
import { useDB } from "../../context/DynamoDBContext";
import { useQueryClient, useQuery } from "@tanstack/react-query";
import { useReload } from "../../context/ReloadContext";
import { getTosConfigurations } from "../../api/ConfigurationApi";
import { toast } from "react-toastify";
import { convertTime2 } from "../../common/ConvertTime";
import { useSelector } from "react-redux";
import api from "../../api/configAxios";
import Controller from "../../common/controller";

const TermOfCondition = () => {
  const { dynamoDBClient } = useDB();
  const queryClient = useQueryClient();
  const { reload } = useReload();
  const { access_token } = useSelector((state) => state.userKeyRed);
  const [value, setValue] = useState(RichTextEditor.createEmptyValue());
  const [html, setHtml] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [error, setError] = useState("");
  const [enableApi, setEnableApi] = useState(false);
  const [data, setData] = useState([]);
  const [disableIcons, setDisableIcons] = useState(false);
  const [version, setVersion] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    setEnableApi(true);
  }, []);

  useEffect(() => {
    if (reload) {
      queryClient.fetchQuery(["getTosConfigurations"]);
    }
  }, [reload]);

  const handleError = (type) => {
    if (type === "getTosConfigurations") {
      toast.error("Error while loading Configuration", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    if (type === "getTosConfigurationsUnauthorized") {
      toast.error("UnAuthorized. Please Login again.", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }

    if (type === "deleteTosFail") {
      toast.error("An error occurred while Adding Terms of Service.", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }

    if (type === "deleteTosLast") {
      toast.error("Cannot delete the last Terms of Service", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };
  const handleChange = (newValue) => {
    setValue(newValue);
    setHtml(newValue.toString("html"));
  };

  const { data: configData, status: configStatus } = useQuery({
    queryKey: ["getTosConfigurations"],
    queryFn: () => getTosConfigurations(access_token),
    enabled: enableApi,
    onSuccess: (data) => {
      if (data.length > 0) {
        setData(data);
      }
      setEnableApi(false);
    },
    onError: (error) => {
      console.log("getTosConfigurations :", error);
      if (error.response.status === 401) {
        handleError("getTosConfigurationsUnauthorized");
      } else {
        handleError("getTosConfigurations");
      }
    },
  });

  const updateTosConfigurations = async () => {
    try {
      setDisableIcons(true);
      setBtnDisable(true);
      if (html === null || html == "") {
        setError("Please enter Terms of Service");
        setDisableIcons(false);
        setBtnDisable(false);
        return;
      }
      if (version === null || version == "") {
        setError("Please enter Version");
        setDisableIcons(false);
        setBtnDisable(false);
        return;
      }
      setError("");
      
      // Wrap the HTML content with SF Pro font styling
      const styledHtml = `<div style="font-family: 'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, sans-serif;">${html}</div>`;
      
      var response = await api.post(
        `${Controller.dynamoDB}/TermOfService`,
        {
          termsOfServices: styledHtml,
          version: version,
          createdBy: "Admin",
        },
        {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        }
      );

      if (response.status === 201) {
        setValue(RichTextEditor.createEmptyValue());
        setHtml("");
        setVersion("");
        setBtnDisable(false);
        setError("");
        toast("Terms of Service added successfully");
        queryClient.fetchQuery(["getTosConfigurations"]);
      }
      setDisableIcons(false);
    } catch (error) {
      console.error("Error updating Terms of Service:", error);
      setBtnDisable(false);
      setDisableIcons(false);
      if (error.response.status === 401) {
        handleError("getTosConfigurationsUnauthorized");
      } else {
        setError("An error occurred while Adding Terms of Service");
      }
    }
  };

  const removeTos = async (id) => {
    try {
      if (data.length === 1) {
        handleError("deleteTosLast");

        return;
      }
      setDisableIcons(true);
      setBtnDisable(true);
      setError("");
      const response = await api.delete(
        `${Controller.dynamoDB}/TermOfService/${id}`,
        {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        }
      );
      if (response.status === 200) {
        toast("Terms of Service deleted successfully");
        queryClient.fetchQuery(["getTosConfigurations"]);
      } else {
        handleError("deleteTosFail");
      }
      setDisableIcons(false);
      setBtnDisable(false);
    } catch (error) {
      console.error("Error deleting Terms of Service:", error);
      setDisableIcons(false);
      setBtnDisable(false);
      if (error.response && error.response.status === 401) {
        handleError("getTosConfigurationsUnauthorized");
      } else {
        handleError("deleteTosFail");
      }
    }
  };

  return (
    <TosPageStyle>
      <TopBar authorized={true} />
      <MainBodyStyle>
        <HeadingStyle>Terms of Services</HeadingStyle>
        <div className="configurationCardWidth configurationCard">
          <div className="configurationCardContainer">
            <p className="label">Terms Of Service :</p>
            <RichTextEditor
              value={value}
              onChange={handleChange}
              placeholder="Enter Terms of Service..."
            />
          </div>
          <div className="configurationCardContainer">
            <div className="label-div">
              <p className="label">Version :</p>
            </div>

            <input
              value={version}
              onChange={(e) => setVersion(e.target.value)}
              type="text"
              id="version"
              maxLength={30}
              placeholder="Enter Version (e.g. v1.0)"
              className="form-control mt-1 input-field"
            />
          </div>
          <button
            type="submit"
            className={"btn form-button"}
            disabled={btnDisable}
            onClick={updateTosConfigurations}
          >
            Add Terms of Service
          </button>
          {error !== "" && <TextErrorStyle>{error}</TextErrorStyle>}
        </div>
        <div>
          <div className="table-container">
            <div className="table-div2">
              <table className="table table-hover">
                <thead className="table-head">
                  <tr>
                    <th scope="col" className="table-item">
                      #
                    </th>
                    <th scope="col" className="table-item">
                      Terms of Service
                    </th>
                    <th scope="col" className="table-item">
                      Version
                    </th>
                    <th scope="col" className="table-item">
                      Created By
                    </th>
                    <th scope="col" className="table-item">
                      Date Created
                    </th>
                    <th scope="col" className="table-item">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {configStatus === "loading" || reload ? (
                    <tr>
                      <td colSpan={6}>
                        <p className="table-loading">Loading...</p>
                      </td>
                    </tr>
                  ) : data.length === 0 ? (
                    <tr>
                      <td colSpan={6}>
                        <p className="table-loading">
                          No Terms Of Services Added
                        </p>
                      </td>
                    </tr>
                  ) : (
                    data.map((item, index) => (
                      <tr key={index}>
                        <th scope="row" className="table-item">
                          {index + 1}
                        </th>
                        <td className="table-item table-item2">
                          {getPreviewText(item.termOfService, 40)}
                        </td>
                        <td className="table-item table-item2">
                          {item.version}
                        </td>
                        <td className="table-item table-item2">
                          {item.createdBy}
                        </td>
                        <td className="table-item table-item2">
                          {convertTime2(item.dateCreated)}
                        </td>
                        <td className="table-item">
                          <i
                            title="Edit"
                            className={
                              disableIcons
                                ? "bi bi-pencil edit-icon disable-icon"
                                : "bi bi-pencil edit-icon"
                            }
                            onClick={() => {
                              setValue(
                                RichTextEditor.createValueFromString(
                                  item.termOfService,
                                  "html"
                                )
                              );
                              setHtml(item.termOfService);
                            }}
                          />
                          <i
                            title="Delete"
                            className={
                              disableIcons
                                ? "bi bi-trash delete-icon disable-icon"
                                : "bi bi-trash delete-icon"
                            }
                            onClick={() => {
                              removeTos(item.tosId);
                            }}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </TosPageStyle>
  );
};

const getPreviewText = (html, maxLength = 60) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html || "";
  const text = tempDiv.textContent || tempDiv.innerText || "";
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

export default TermOfCondition;
